























































































































import Vue from 'vue';
import axios from 'axios';

export default Vue.extend({
  name: 'SettingsUsers',
  data: () => ({
    tableData: [],
    modalEdit: false,
    modalDelete: false,
    validForm: false,
    userGroups: [],
    search: '',
    user: {
      ID: 0,
      login: '',
      password: '',
      name: '',
      email: '',
      IDgroups: [],
      trainingsAdmin: false,
      admin: false,
    },
    headers: [
      { text: 'Jméno', value: 'name', width: '20%' },
      { text: 'Login', value: 'login', width: '20%' },
      { text: 'Skupiny', value: 'groupsString', width: '50%' },
      { text: 'Správce', value: 'trainingsAdmin', width: '10%' },
      { sortable: false, width: '48px' },
    ],
    rules: {
      required: (value: string) => !!value || 'Pole je povinné',
      number: (value: string) => {
        const pattern = /^\d+$/;
        return pattern.test(value) || 'Hodnota musí být číslo!!!';
      },
    },
  }),
  watch: {},
  mounted() {
    this.userGroupsLoad();
    this.$nextTick(function () {
      this.dataLoad();
    });
  },
  methods: {
    dataLoad() {
      axios
        .get('/api/v1/users')
        .then((response) => {
          for (const row of response.data) {
            row.groupsString = '';
            for (const userGroup of row.IDgroups) {
              let group: { ID: number; name: string };
              for (group of this.userGroups) {
                if (group.ID === userGroup) {
                  row.groupsString = row.groupsString + ', ' + group.name;
                }
              }
            }
            row.groupsString = row.groupsString.substring(2);
          }
          this.tableData = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    dataNew() {
      this.user = { ...this.user, ...((this.$options as Vue & { data: () => object }).data() as Vue & { user: object }).user };
      this.modalEdit = true;
      this.$nextTick(function () {
        (this.$refs.userForm as Vue & { validate: () => boolean }).validate();
      });
    },
    dataSave() {
      if ((this.$refs.userForm as Vue & { validate: () => boolean }).validate() !== true) {
        this.$store.commit('globalMessage', 'Formulář obsahuje chyby!!!');
      } else {
        if (this.user.ID === 0) {
          axios
            .post('/api/v1/users', this.user)
            .then((response) => {
              if (response.data.status === 'recordExists') {
                this.$store.commit('globalMessage', 'Zadaný uživatel již existuje');
              } else {
                this.dataLoad();
                this.modalEdit = false;
              }
            })
            .catch((err) => {
              this.$store.dispatch('catchErrHandler', err);
            });
        } else {
          axios
            .put('/api/v1/users', this.user)
            .then((response) => {
              if (response.data.status === 'recordExists') {
                this.$store.commit('globalMessage', 'Zadaný uživatel již existuje');
              } else {
                this.dataLoad();
                this.modalEdit = false;
              }
            })
            .catch((err) => {
              this.$store.dispatch('catchErrHandler', err);
            });
        }
      }
    },
    dataDelete() {
      axios
        .delete(`/api/v1/users/${this.user.ID}`)
        .then(() => {
          this.dataLoad();
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
      this.modalEdit = false;
      this.modalDelete = false;
    },
    userGroupsLoad() {
      axios
        .get('/api/v1/group')
        .then((response) => {
          this.userGroups = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
  },
});
